import * as React from 'react'
import { CardClass } from '@sphinx/components-styles'
import * as classNames from 'classnames'

export const Card: React.FC<React.HTMLAttributes<HTMLElement>> = ({
  children,
  className,
  ...props
}) => (
  <section className={classNames(CardClass.container, className)} {...props}>
    {children}
  </section>
)

export const Header: React.FC<React.HTMLAttributes<HTMLElement>> = ({
  children,
  className,
  ...props
}) => (
  <header className={classNames(CardClass.header, className)} {...props}>
    {children}
  </header>
)

export const Title: React.FC<React.HTMLAttributes<HTMLHeadingElement>> = ({
  children,
  className,
  ...props
}) => (
  <h1 className={classNames(CardClass.title, className)} {...props}>
    {children}
  </h1>
)

export const CardActionBar: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...props
}) => (
  <div className={className} {...props}>
    {children}
  </div>
)

export const Footer: React.FC<React.HTMLAttributes<HTMLElement>> = ({
  children,
  className,
  ...props
}) => (
  <footer className={classNames(CardClass.footer, className)} {...props}>
    {children}
  </footer>
)
